export enum GuestSurveyForms {
  GetSurvey = 'GetSurvey',
  AddGuestSurveyResponse = 'AddGuestSurveyResponse',
  StartGuestSurvey = 'StartGuestSurvey',
  SubmitGuestSurvey = 'SubmitGuestSurvey',
  UpdateGuestSurvey = 'UpdateGuestSurvey',
}
